const SELECT_MENU_SEARCH_ID = 'font-search-input';
const BRAND_FONT_LIST_ID = 'brand-font-list';
const BRAND_FONT_OPTION_PREFIX = 'brand-font-option-';
const DOCUMENT_FONT_LIST_ID = 'document-font-list';
const UPLOADED_FONT_LIST_ID = 'uploaded-font-list';
const UPLOADED_FONT_OPTION_PREFIX = 'uploaded-font-option-';
const DOCUMENT_FONT_OPTION_PREFIX = 'document-font-option-';
const OPTION_CONTAINER_ID = 'select-list-box';
const BRAND_DROPDOWN_TRIGGER_CLASSNAME = 'font-brand-dropdown-trigger';
const BRAND_DROPDOWN_CONTAINER_CLASSNAME = 'font-brand-dropdown-container';
const FONT_UPLOAD_BUTTON_ID = 'font-upload-button';

export {
  SELECT_MENU_SEARCH_ID,
  BRAND_FONT_LIST_ID,
  BRAND_FONT_OPTION_PREFIX,
  DOCUMENT_FONT_LIST_ID,
  DOCUMENT_FONT_OPTION_PREFIX,
  UPLOADED_FONT_LIST_ID,
  UPLOADED_FONT_OPTION_PREFIX,
  OPTION_CONTAINER_ID,
  BRAND_DROPDOWN_TRIGGER_CLASSNAME,
  BRAND_DROPDOWN_CONTAINER_CLASSNAME,
  FONT_UPLOAD_BUTTON_ID,
};
